import { catchError, map, mergeMap, of, pipe } from 'rxjs';
import { type RequestActionCreator } from '@/types';
import { getApiErrorMessage } from '../utils';

export const request = <P, S, R>(
  requestFn: (payload: any) => Promise<R>,
  responseAction: RequestActionCreator<P, S>,
) =>
  pipe(
    mergeMap((payload) =>
      of(payload).pipe(
        mergeMap(requestFn),
        map((a) => responseAction.succeeded(a)),
        catchError((error) =>
          of(responseAction.failed(getApiErrorMessage(error))),
        ),
      ),
    ),
  );
